'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _AntiForgeryToken = require('../AntiForgeryToken');

var _AntiForgeryToken2 = _interopRequireDefault(_AntiForgeryToken);

var _AnimatedInput = require('../AnimatedInput');

var _AnimatedInput2 = _interopRequireDefault(_AnimatedInput);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App', 'Security');

var LoginForm = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(LoginForm, _React$PureComponent);

    function LoginForm(props) {
        (0, _classCallCheck3.default)(this, LoginForm);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).call(this, props));

        _this.submit = function (e) {
            e.preventDefault();
            (0, _ajax2.default)({
                url: '/Account/Verify',
                method: 'post',
                contentType: 'application/json',
                dataType: 'json',
                data: (0, _stringify2.default)({
                    Email: _this.state.email,
                    Password: _this.state.password
                })
            }).done(function (res) {
                // Perform real login form submit
                if (res === true) {
                    window.location.hash = "#3";
                    window.location.reload();
                } else {
                    _this.setState((0, _extends3.default)({}, _this.state, { invalidCredentials: true }));
                }
            }).fail(function (err) {});
        };

        _this.emailChanged = function (e) {
            _this.setState((0, _extends3.default)({}, _this.state, { email: e.target.value }));
        };

        _this.passwordChanged = function (e) {
            _this.setState((0, _extends3.default)({}, _this.state, { password: e.target.value }));
        };

        _this.state = {
            email: '',
            password: '',
            invalidCredentials: false
        };
        return _this;
    }

    (0, _createClass3.default)(LoginForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'cartLogin cart-step3__form' },
                _react2.default.createElement(
                    'h3',
                    { className: 'cart__section-title' },
                    Resx.App.LoginInCart
                ),
                _react2.default.createElement(
                    'form',
                    { ref: function ref(el) {
                            return _this2.loginForm = el;
                        }, className: 'cart__form',
                        action: '/Account/Login?returnUrl=%2FCart%233', method: 'post' },
                    _react2.default.createElement(_AntiForgeryToken2.default, null),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form__input col-sm-6' },
                            _react2.default.createElement(_AnimatedInput2.default, { className: 'input', type: 'text', id: 'Email', name: 'Email',
                                value: this.state.email, onChange: this.emailChanged }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'Email' },
                                _react2.default.createElement('i', { className: 'icon--mail' }),
                                ' ',
                                Resx.App.Email
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form__input col-sm-6' },
                            _react2.default.createElement(_AnimatedInput2.default, { className: 'input', type: 'password', id: 'Password', name: 'Password',
                                value: this.state.password, onChange: this.passwordChanged }),
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'Password' },
                                _react2.default.createElement('i', { className: 'icon--key' }),
                                ' ',
                                Resx.App.Password
                            )
                        ),
                        this.state.invalidCredentials && _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 warning__message' },
                            _react2.default.createElement(
                                'small',
                                { className: 'red' },
                                Resx.Security.InvalidUsernameOrPassword
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'text-center mt-3 mb-2 clearfix' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn--sm btn--green', onClick: this.submit },
                            Resx.Common.LogIn
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn--sm mx-2', onClick: this.props.goBack },
                            Resx.Common.Back
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: ' mt-3 mb-2 clearfix under-login-form' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: '/Account/ForgotPassword' },
                                Resx.App.ForgottenPassword
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: '#', onClick: this.props.show },
                                Resx.App.RegisterButton
                            )
                        )
                    )
                )
            );
        }
    }]);
    return LoginForm;
}(_react2.default.PureComponent), _class.propTypes = {
    goBack: _propTypes2.default.func,
    show: _propTypes2.default.func
}, _temp);
exports.default = LoginForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/LoginForm.js
// module id = 1034
// module chunks = 0